import { Tooltip } from 'components/common';
import { Icon } from 'components/common/icons';

import type { IconProp } from 'components/common/icons/Icon';

interface Props {
  icon: IconProp;
  iconStyle?: React.CSSProperties;
  number?: number;
  style?: React.CSSProperties;
  tooltip?: string;
}

const IconWithNumber = ({ icon, iconStyle, number, style, tooltip }: Props) => (
  <Tooltip childrenWrapInDiv={false} content={tooltip}>
    <div className="icon-with-number" style={style}>
      <Icon icon={icon} style={iconStyle} />

      {number}

      <style jsx>{`
        .icon-with-number {
          align-items: center;
          display: flex;
          font-size: 1.5rem;
          font-weight: 600;
          gap: 6px;
        }
      `}</style>
    </div>
  </Tooltip>
);

export default IconWithNumber;
